import React from 'react';
import { Switch, Box, Typography, styled } from '@mui/material';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 60,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    padding: 1,
    transform: 'translateX(-2px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(25px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.blue.main,
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 28,
    height: 28,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 20,
    backgroundColor: '#ccc',
    opacity: 1,
  },
}));

const ToggleSwitch = ({ checked, onCheck, checkedText, unCheckedText }) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <CustomSwitch checked={checked} onChange={(e) => onCheck(e.target.checked)} />
      <Typography variant="body2" >{checked ? checkedText : unCheckedText}</Typography>
    </Box>
  );
};

export default ToggleSwitch;






const CustomTwoSwitch = styled(Switch)(() => ({
  width: 58,
  height: 32,
  padding: 0,

  "& .MuiSwitch-switchBase": {
    padding: 2,
    transform: "translateX(2px)",
    transition: "transform 0.25s ease",

    "&.Mui-checked": {
      transform: "translateX(26px)",
      color: "#fff",
    },
  },

  "& .MuiSwitch-thumb": {
    width: 26,
    height: 26,
    backgroundColor: "#fff",
    borderRadius: "50%",
    boxShadow: "0 2px 4px rgba(0,0,0,0.25)",
  },

  /* ✅ FORCE TRACK COLOR ALWAYS */
  "& .MuiSwitch-track": {
    borderRadius: 20,
    backgroundColor: "#4169E1 !important",
    opacity: "1 !important",
  },

  /* ✅ FORCE EVEN WHEN CHECKED */
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#4169E1 !important",
    opacity: "1 !important",
  },
}));




export const ToggleTwoSwitch = ({ checked, onCheck }) => {
  return (
    <Box display="flex" alignItems="center" gap={1.5}>
      
      {/* LEFT LABEL */}
      <Typography
        fontSize={14}
        fontWeight={!checked ? 600 : 400}
        color={!checked ? "blue.main" : "#000"}
      >
        School
      </Typography>

      {/* SWITCH */}
      <CustomTwoSwitch
        checked={checked}
        onChange={(e) => onCheck(e.target.checked)}
      />

      {/* RIGHT LABEL */}
      <Typography
        fontSize={14}
        fontWeight={checked ? 600 : 400}
        color={checked ? "blue.main" : "#000"}
      >
        Publisher
      </Typography>

    </Box>
  );
};

